$(function(){
    $(document).on('click', '.filter-container .view-less', function () {
        $('.filter-container').addClass('less');
    });

    $(document).on('click', '.filter-container .view-more', function () {
        $('.filter-container').removeClass('less');
    });
});